import { render } from "./ProductInfo.vue?vue&type=template&id=12e812a4&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=js"
export * from "./ProductInfo.vue?vue&type=script&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=12e812a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e812a4"]])

export default __exports__